module.exports = __webpack_public_path__ + "img/a6.8ff094e9.png";